import React, { useState } from "react";

export default function Step3({ formData, updateFormData, prevStep, submitForm, loading, message }) {
  const [errors, setErrors] = useState({});

  const handleSelfieChange = (e) => {
    if (e.target.files[0]) {
      updateFormData({ selfie: e.target.files[0] });
      setErrors({ ...errors, selfie: "" });
    }
  };

  const handleSubmit = async () => {
    const newErrors = {};
    if (!formData.selfie) {
      newErrors.selfie = "Обязательное поле";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    // Вызываем функцию отправки, переданную из родителя
    await submitForm();
  };

  return (
    <div className="form-inner">
      <h2 className="form-title">Подтвердите личность по фото</h2>

      <div className="upload-container-main">
        <div className="upload-item-box">
          <span className="upload-label">Сделайте селфи с паспортом в руках</span>
          
          <label className="btn-upload-action">
            <span className="icon-box">📥</span> Загрузить селфи
            <input
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleSelfieChange}
            />
          </label>

          {formData.selfie && (
            <div className="file-ready-badge">✅ {formData.selfie.name}</div>
          )}

          {errors.selfie && <span className="error-hint">{errors.selfie}</span>}
        </div>
      </div>

      {message && (
        <div className={`status-alert ${message.includes("✅") ? "success" : "error"}`}>
          {message}
        </div>
      )}

      <div className="form-footer-right">
        <span className="step-text">Шаг: 3/3</span>
        <div className="nav-buttons-group">
          <button 
            className="btn-back-white" 
            onClick={prevStep}
            disabled={loading}
          >
            ← Назад
          </button>
          <button
            className="btn-next-main"
            onClick={handleSubmit}
            disabled={loading}
          >
            {loading ? "Отправка..." : "Отправить заявку →"}
          </button>
        </div>
      </div>
    </div>
  );
}